import { assign, createMachine, sendParent, sendTo, spawn } from 'xstate';
import { AUTOPAY_MACHINE_STATES_NAMES } from '../../const/machines';
import { formMachine } from '../../xform';
import { submitSuccessAnalyticsHandler } from './helpers';
import paymentAmountConfig from './paymentAmountConfig';
import paymentMethodConfig from './paymentMethodConfig';
import paymentOptionConfig from './paymentOptionConfig';
export default /** @xstate-layout N4IgpgJg5mDOIC5QEMCuAXA9gB2QTwFlkBjACwEsA7MAYgGEBBAOToFEAZAbQAYBdRUNkyxy6cpkoCQeRAFoAHPIB0ATgDsANgCsGgExaANCAAeiACxatq9QGY1Ws4t3yAjPoC+7o2iy5CJCmp6dgB5AGVWHn4kECERMQkpGQQFZXVtPUMTc0trNTsHJ1cPLxAfHHwiMipaAmYGAHFWAH0GAFUAFRCABQYATSipONFxSRjk1NVNHX0jUwQLKxVbe0d5ZzctT28MCv9q6iVIURowtro2MLDBmOGEsdB5lzUVJW4tbhszMxt5X++sskXGZdNwlLp7CpfipHLoIRptmVdn4qoEwEcICdWAAlbEhbE3QTCEaJGLzL4aJQ2bj2P7yZYOLQqIxA3Q2KzPMxqeQabjLbncxHlFEBGpKAC2yEoyBgp3Ol2ufCGxPuUnmZhcNnBENBGk1uhUWl0LMQLjNlK0ak0ii58gsaiFyMqosOkulspxeIJStuKtGasQlmUnws3A0LzU3B+gMQKm4aU+KlB8h07KNnlKlEwEDgUmFzoOYGV8X9ZLkjhNKWealUWhswJs7Ns9MdvgLaIxomLJIe2QQ3ErP10rb2qLFbplRd9JdJj0QA+kgfDqh56T07PZw9K+f2HdgqGIxDg8GnPYD-crka1tkNNl0XJpnxHIsLRwATm-MG-u6qyxfFwgfyvCovJJio8iRrylgZu4QA */ createMachine({
    context: {
        apiMachineRef: undefined,
        errorType: undefined,
        hasPaymentMethodBusinessValidationError: false,
        isPaymentTypeVisible: false,
        successType: undefined,
        triggerAnalyticsEvent: () => undefined
    },
    schema: { events: {} },
    predictableActionArguments: true,
    initial: AUTOPAY_MACHINE_STATES_NAMES.INITIAL,
    id: 'autopayMachine',
    states: {
        manage: {
            always: [
                {
                    target: 'edit',
                    cond({ apiMachineRef }) {
                        const { data } = apiMachineRef.getSnapshot().context.autopayStatusQueryResult;
                        return !(data === null || data === void 0 ? void 0 : data.enrollment);
                    }
                }
            ],
            on: {
                SUCCESS: {
                    target: AUTOPAY_MACHINE_STATES_NAMES.SUCCESS,
                    actions: 'handleAutopaySuccess'
                },
                ERROR: {
                    target: AUTOPAY_MACHINE_STATES_NAMES.ERROR,
                    actions: 'handleAutopayError'
                },
                EDIT: {
                    target: 'edit'
                }
            }
        },
        edit: {
            entry: [
                assign({
                    form({ apiMachineRef, form }) {
                        if (form) {
                            return form;
                        }
                        return spawn(
                        // DO NOT CHANGE: the order of these configs must mirror the position of the inputs in the UI for the error focus to work
                        formMachine.withContext({
                            fieldConfigs: [
                                paymentOptionConfig(apiMachineRef),
                                paymentAmountConfig(apiMachineRef),
                                paymentMethodConfig(apiMachineRef)
                            ]
                        }), {
                            name: 'autopayForm'
                        });
                    }
                }),
                sendParent('HOE_UPDATE_BANNER_VISIBILITY')
            ],
            on: {
                SET_NEW_PAYMENT_METHOD: {
                    actions: [
                        sendTo(({ apiMachineRef }) => apiMachineRef, {
                            type: 'FETCH_PAYMENT_METHODS'
                        }),
                        'sendToPaymentMethodField'
                    ]
                },
                SUCCESS: {
                    target: AUTOPAY_MACHINE_STATES_NAMES.SUCCESS,
                    actions: 'handleAutopaySuccess'
                },
                ERROR: {
                    target: AUTOPAY_MACHINE_STATES_NAMES.ERROR,
                    actions: 'handleAutopayError'
                }
            }
        },
        success: {
            entry: [
                sendParent('HOE_UPDATE_BANNER_VISIBILITY'),
                {
                    type: 'triggerAnalyticsEvent',
                    eventOptions: submitSuccessAnalyticsHandler
                },
                sendParent({ type: 'INCREMENT_CONVERSION' }),
                /*
                 * We need to force fetch account summary so that the updated enrollment status will
                 * be reflected in the account card MFE
                 */
                sendTo(({ apiMachineRef }) => apiMachineRef, {
                    type: 'FETCH_ACCOUNT_SUMMARY',
                    force: true
                }),
                // We need to force fetch payment methods API if an alternate payment method was used
                sendTo(({ apiMachineRef }) => apiMachineRef, {
                    type: 'FETCH_PAYMENT_METHODS',
                    force: true
                }),
                // We need to force fetch payment enterprise eligibility API to reflect the current eligibility
                sendTo(({ apiMachineRef }) => apiMachineRef, {
                    type: 'FETCH_PAYMENT_ELIGIBILITY',
                    force: true
                })
            ]
        },
        error: {
            entry: sendParent('HOE_UPDATE_BANNER_VISIBILITY')
        },
        cancelled: {
            type: 'final',
            entry: sendParent({ type: 'CANCEL' })
        }
    },
    on: {
        CANCEL: {
            target: 'cancelled'
        }
    }
}, {
    actions: {
        triggerAnalyticsEvent: (context, event, meta) => {
            const { triggerAnalyticsEvent } = context;
            triggerAnalyticsEvent(meta.action.eventOptions(context));
        },
        handleAutopayError: assign({
            errorType: (context, event) => event.errorType,
            hasPaymentMethodBusinessValidationError: (context, { hasPaymentMethodBusinessValidationError }) => hasPaymentMethodBusinessValidationError
        }),
        handleAutopaySuccess: assign({
            successType: (context, event) => event.successType
        }),
        sendToPaymentMethodField: sendTo(({ form }) => {
            return form.getSnapshot().context.actors.paymentMethod;
        }, (context, { paymentMethodId }) => {
            return {
                type: 'CHANGE',
                value: paymentMethodId
            };
        })
    }
});
